// NOOVI: Análise Comercial — feature nativa NooviChat (fase-31)
import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/commercial-analysis'),
      name: 'commercial_analysis',
      component: () => import('./CommercialAnalysisIndex.vue'),
      meta: {
        permissions: ['administrator', 'agent'],
        featureFlag: FEATURE_FLAGS.COMMERCIAL_ANALYSIS,
      },
    },
  ],
};
